export const handleOpenSupportChat = (prefilledMsg = '') => {
  window.Intercom("showNewMessage", prefilledMsg);
};